<template>
  <ul class="dashboard-list">
    <link-item v-for="item in list"
               :key="item.id"
               v-if="item.show"
               :item="item"></link-item>
  </ul>
</template>

<script>
  import scriptsIcon from '../../Svg/dashboard/scriptsIcon'
  import usersIcon from '../../Svg/dashboard/usersIcon'
  import thingsIcon from '../../Svg/dashboard/thingsIcon'
  import vidgetsIcon from '../../Svg/dashboard/vidgetsIcon'
  import dashboardsIcon from '../../Svg/dashboard/dashboardsIcon'
  import logsIcon from '../../Svg/dashboard/logsIcon'
  import journalIcon from '../../Svg/dashboard/journalIcon'
  import linkItem from './linkItem'
  import {mapGetters} from 'vuex'
  import projectsIcon from '../../Svg/dashboard/prjectsIcon'

  export default {
    name: 'linkList',
    components: {
      scriptsIcon,
      usersIcon,
      thingsIcon,
      vidgetsIcon,
      dashboardsIcon,
      logsIcon,
      journalIcon,
      linkItem,
      projectsIcon
    },
    data() {
      return {

      }
    },
    computed: {
      ...mapGetters({
        adminRole: 'auth/adminRole'
      }),
      list() {
        return [
          // {
          //   id: 0,
          //   to: '/scripts',
          //   icon: scriptsIcon,
          //   name: this.$t('index.scripts.title'),
          //   desc: this.$t('index.scripts.desc'),
          //   show: true,
          // },
          {
            id: 0,
            to: '/projects',
            icon: projectsIcon,
            name: this.$t('menu.projects'),
            desc: this.$t('index.projectsDesc'),
            show: true
          },
          {
            id: 1,
            to: '/roles',
            icon: usersIcon,
            name: this.$t('index.users.title'),
            desc: this.$t('index.users.desc'),
            show: this.adminRole,
          },
          {
            id: 3,
            to: '/things',
            icon: thingsIcon,
            name: this.$t('index.things.title'),
            desc: this.$t('index.things.desc'),
            show: true,
          },

          // {
          //   id: 4,
          //   to: '/vidgets',
          //   icon: vidgetsIcon,
          //   name: this.$t('index.widgets.title'),
          //   desc: this.$t('index.widgets.desc'),
          //   show: true
          // },
          // {
          //   id: 5,
          //   to: '/dashboards',
          //   icon: dashboardsIcon,
          //   name: this.$t('index.dashboard.title'),
          //   desc: this.$t('index.dashboard.desc'),
          //   show: true
          // },
          // {
          //   id: 6,
          //   to: '/logs',
          //   icon: logsIcon,
          //   name: this.$t('index.logs.title'),
          //   desc: this.$t('index.logs.desc'),
          //   show: true
          // },
          {
            id: 7,
            to: '/journals',
            icon: journalIcon,
            name: this.$t('index.journal.title'),
            desc: this.$t('index.journal.desc'),
            show: true
          }
        ]
      }
    }
  }
</script>

<style lang="scss">
  .dashboard-list {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px;


    .dashboard-item {
      width: calc(25% - 30px);
      margin: 0 15px 30px;
      display: flex;

      .dashboard-item_link {
        width: 100%;
        padding: 35px 35px 40px;
        background: white;
        border-radius: 4px;
        transition: $anim;
        flex-direction: column;
        text-align: left;
        outline: none;
      }

      @media screen and (max-width: 1780px) {
        width: calc(33.3333% - 30px);
      }

      @media screen and (max-width: 1280px) {
        width: calc(50% - 30px);
      }
    }

    .icon {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      border: 1px solid rgba(0, 82, 127, .2);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 25px;
      transition: $anim;

      .svg {
        path {
          transition: $anim;
        }
      }
    }

    .name {
      font-family: $msb;
      font-size: 18px;
      letter-spacing: .25px;
      color: $darkBlue;
      margin-bottom: 10px;
      transition: $anim;
    }

    .desc {
      font-family: $mr;
      font-size: 14px;
      color: $darkBlue;
    }

    .dashboard-item:hover .dashboard-item_link,  .dashboard-item_link:focus {
      box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);

      .name {
        color: $lightBlue;
      }

      .icon {
        background: $lightBlue;
        border-color: $lightBlue;
        box-shadow: 0 0 0 10px rgba(41, 171, 226, .1);
      }

      .svg path {
        fill: white;
      }
    }
  }
</style>
